import { DEFAULT_PAGE } from 'core/constants/platform.constants';
import type { IBannerVisualizationFilterValues, IUpdateBannerTargetByPlatform } from 'core/model/interfaces/banners';
import type { IFiltersPlatform, IPaginationByPlatform, IQueryByPlatform } from 'core/model/interfaces/filters';
import type { TSliceReducer } from 'core/store';
import { INITIAL_STATE_FOR_VISUALIZATION_TAB } from './constants';
import type { IBannersState, TUpdateBannerListByToggle } from './types';

const updateBannersCreationTabPage: TSliceReducer<IBannersState, IPaginationByPlatform> = (state, action) => {
  const { platform, page } = action.payload;

  state.creationTab[platform].pagination.currentPage = page ?? 1;
};

const updateBannersVisualizationTabPage: TSliceReducer<IBannersState, IBannerVisualizationFilterValues> = (
  state,
  action,
) => {
  const { platform, page } = action.payload;

  state.visualizationTab[platform].pagination.currentPage = page ?? DEFAULT_PAGE;

  state.visualizationTab[platform].branchIdList =
    action.payload.branchIdList ?? state.visualizationTab[platform].branchIdList;

  state.visualizationTab[platform].priceListIdList =
    action.payload.priceListIdList ?? state.visualizationTab[platform].priceListIdList;
};

const resetBannersVisualizationTabFilters: TSliceReducer<IBannersState, IFiltersPlatform> = (state, action) => {
  const { platform } = action.payload;

  state.visualizationTab[platform].branchIdList = INITIAL_STATE_FOR_VISUALIZATION_TAB.branchIdList;

  state.visualizationTab[platform].priceListIdList = INITIAL_STATE_FOR_VISUALIZATION_TAB.priceListIdList;

  state.visualizationTab[platform].pagination.currentPage = INITIAL_STATE_FOR_VISUALIZATION_TAB.pagination.currentPage;

  state.visualizationTab[platform].banners = INITIAL_STATE_FOR_VISUALIZATION_TAB.banners;
};

/**
 * The `query` could be `undefined` because the backend API requires it to be optional.
 *
 * If this is less than the minimum search length, it will be set to `undefined` to avoid sending an empty query.
 *
 * @todo Unify the filters to reset the page to 1 when the query changes.
 */
const updateBannersQuery: TSliceReducer<IBannersState, IQueryByPlatform> = (state, action) => {
  const { platform, query } = action.payload;

  state.creationTab[platform].query = query;
};

/**
 * @todo Unify the filters to reset the page to 1 when the target changes.
 */
const updateBannerTarget: TSliceReducer<IBannersState, IUpdateBannerTargetByPlatform> = (state, action) => {
  const { platform, target } = action.payload;

  state.creationTab[platform].target = target;
};

const toggleBannerListItem: TSliceReducer<IBannersState, TUpdateBannerListByToggle> = (state, action) => {
  const { platform, id, isActive } = action.payload;

  const banner = state.creationTab[platform].banners.find(banner => banner.id === id);

  if (banner) {
    banner.isActive = isActive;
  }
};

export const reducers = {
  updateBannersCreationTabPage,
  updateBannersVisualizationTabPage,
  resetBannersVisualizationTabFilters,
  updateBannersQuery,
  updateBannerTarget,
  toggleBannerListItem,
};
